$(document).ready(function () {
    /* ========================================================================
    *   Scrolled Header
    * ======================================================================== */
    function headerAnimation() {
        if ($(document).scrollTop() > 50) {
            $("body").addClass("scrolled");
        }
        else {
            $("body").removeClass("scrolled");
        }
    }
    headerAnimation();
    $(window).resize(headerAnimation);

    $(window).scroll(function () {
        headerAnimation();
        $(window).resize(headerAnimation);
    });

    /* ========================================================================
    * Header Responsive Interaction
    * ======================================================================== */
    $('.navbar-toggler').on('click', function () {
        $('body').toggleClass('menu-open');
    });
    $(window).resize(function () {
        var vw = $(window).innerWidth();

        if ($('body').hasClass('menu-open') && vw >= 991) {
            $('body').removeClass('menu-open');
        }
    });

    /* ========================================================================
    * Calculator Result Interaction
    * ======================================================================== */
    $('.calculator-results__estimation button').click(function (e) {
        $('body').toggleClass('results-open');
    });
});
